import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';

const propTypes = {
  text: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  appear: PropTypes.bool,
};

const ErrorField = ({ text ="", children, className = "", appear = false }) => {
  if(appear === true && !text && !children) return null;
  return (
    <div className={`${errorClass} ${className}`}>{text}{children}</div>
  );
}

ErrorField.propTypes = propTypes;
export default ErrorField;

const errorClass = css`
  font-size: 12px;
  font-weight: 600;
  color: #fc3666;
  min-height: 17px;
`;


// WEBPACK FOOTER //
// ./src/components/form/ErrorField.jsx